<template>
  <section class="block-cars cars">
    <header class="cars__header">
      <h2 class="cars__title">Модельный ряд</h2>
    </header>
    <div class="cars__container container">
      <car
        class="cars__car"
        v-for="car in cars"
        :key="`car-${car.key}`"
        :data="car"
        @getCall="getCall"
        @openFullGallery="(car, i) => openGallery(car, i)"
      />
    </div>

    <transition name="fade">
      <gallery-viewer ref="viewer" />
    </transition>
  </section>
</template>

<script>
import Mixin from "@/common/mixin";
import CARS from "@/common/cars-info.js"
import Car from './car.vue';
import GalleryViewer from "../gallery-viewer.vue";

export default {
  name: "block-cars",
  components: { Car, GalleryViewer },
  mixins: [Mixin],
  data() {
    return {
      cars: CARS,
    };
  },
  computed: {
    carImageGallery: () => (name, num) => {
      try {
        return require(`../../images/cars/${name}/gallery/${num}.webp`);
      } catch {
        try {
          return require(`../../images/cars/${name}/gallery/${num}.png`);
        } catch {
          return require(`../../images/cars/${name}/gallery/${num}.jpg`);
        }
      }
    },
  },
  methods: {
    openGallery(car, index) {
      let gallery = [];
      for (let i = 1; i <= car.gallery; i++) {
        gallery.push(this.carImageGallery(car.key, i));
      }
      console.log(gallery);
      this.$refs.viewer.open(gallery, index - 1);
    },
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/constants.scss";

.cars {
  width: 100%;
  margin-bottom: 100px;
  font-size: 20px;

  &__container {
    padding: 0 20px;
  }

  &__title {
    margin-bottom: 2em;
    font-size: 1.5em;
    text-align: center;
    text-transform: uppercase;
  }

  &__car:not(:last-child) {
    margin-bottom: 2.5em;
  }
}

@media (max-width: 1920px) {
  .cars {
    font-size: calcFontSize(9, 20, 800, 1920);
  }
}

@media (max-width: 800px) {
  .cars {
    font-size: calcFontSize(10, 20, 360, 800);

    &__container {
      padding: 0 10px;
    }
  }
}
</style>
